/* function getDeliveryDate() {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)

  // Check if today is a weekend or Friday after 1:30 PM
  if (dayOfWeek === 0 || dayOfWeek === 6 || (dayOfWeek === 5 && (hour > 13 || (hour === 13 && minute > 30)))) {
    // Move to next Monday
    const daysUntilMonday = (8 - dayOfWeek) % 7;
    now.setDate(now.getDate() + daysUntilMonday);
  } else if (hour > 13 || (hour === 13 && minute > 30)) {
    // If it's after 1:30 PM on a weekday, move to the next day
    now.setDate(now.getDate() + 1);
  }

  // Adjust for weekends again after adding a day
  if (now.getDay() === 0) { // Sunday
    now.setDate(now.getDate() + 1); // Move to Monday
  } else if (now.getDay() === 6) { // Saturday
    now.setDate(now.getDate() + 2); // Move to Monday
  }

  return now;
}

function formatDate(date) {
  const daysOfWeek = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
  const months = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
    "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
  ];

  const dayName = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];

  return `${dayName}, ${day} de ${month}`;
}

setTimeout(function() {
  const deliveryDate = getDeliveryDate();
  const formattedDeliveryDate = formatDate(deliveryDate);

  $('.date').text(`${formattedDeliveryDate}`);
  console.log(`La fecha de envío es: ${formattedDeliveryDate}`);
}, 400); */

document.addEventListener("DOMContentLoaded", function() {
  console.log("corriendo optimización;");
  document.querySelectorAll('.scrollnav').forEach(function(scrollnav) {
    scrollnav.addEventListener('click', function(event) {
      event.preventDefault();

      var target = document.querySelector(this.getAttribute('data-href'));
      var target_id = this.getAttribute('data-id');

      if (target_id === 'envios') {
        document.querySelectorAll('.product-content__trigger').forEach(input => {
          input.checked = false;
        });
        document.getElementById('product-privacy-policy').checked = true;
      }

      if (target_id === 'cambios') {
        document.querySelectorAll('.product-content__trigger').forEach(input => {
          input.checked = false;
        });
        document.getElementById('product-returns').checked = true;
      }

      if (target_id === 'cuidados') {
        document.querySelectorAll('.product-content__trigger').forEach(input => {
          input.checked = false;
        });
        document.getElementById('product-cleaning').checked = true;
      }


      setTimeout(function() {
        if (target) {
          window.scrollTo({
            top: target.offsetTop + 60,
            behavior: 'smooth'
          });
        }
      }, 50);
    });
  });
});

window.addEventListener('scroll', function() {
  const header = document.querySelector('.main-header-wrapper');
  const navElement = document.querySelector('.main-product-nav-mobile');

  if (!navElement || !header) return;

  if (window.scrollY > 200) {
    const headerHeight = header.offsetHeight - 2;
    navElement.classList.add('mininav-fixed');
    navElement.style.top = `${headerHeight}px`;
  } else {
    navElement.classList.remove('mininav-fixed');
    document.querySelectorAll('.scrollnav').forEach(element => {
      element.classList.remove('active');
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Select all sections with an id attribute
  const sections = document.querySelectorAll('.scrollcheck[id]');
  
  // Function to add 'active' class to the first matching data-href element
  function onScroll() {
    let currentSectionId = '';
    
    sections.forEach(section => {
      const sectionTop = section.offsetTop + 40; // Adjust based on your preference
      const sectionHeight = section.offsetHeight;
      
      if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
        currentSectionId = '#' + section.getAttribute('id');
      }
    });
    
    // Remove 'active' class from all data-href elements
    document.querySelectorAll('[data-href]').forEach(link => {
      link.classList.remove('active');
      link.classList.remove('active-force');
    });
    
    // Add 'active' class to the first element with matching data-href
    if (currentSectionId) {
      const firstMatch = document.querySelector(`[data-href="${currentSectionId}"]`);
      if (firstMatch) {
        firstMatch.classList.add('active');
        document.querySelectorAll('[data-href]').forEach(link => {
          link.classList.remove('active-force');
        });
      }
    }
  }
  
  // Attach the scroll event listener
  window.addEventListener('scroll', onScroll);

  const ctaUseElements = document.querySelectorAll('[data-id="cta-use"]');
  const ctaIngredientsElements = document.querySelectorAll('[data-id="cta-ingredients"]');
  const scrollonElements = document.querySelectorAll('.scrollon');

  if (ctaUseElements.length > 0) {
    ctaUseElements[0].addEventListener('click', function() {
      if (scrollonElements.length > 0) {
        scrollonElements.forEach(function(element) {
          element.classList.remove('active-force', 'active');
        });
      }

      ctaUseElements.forEach(function(element) {
        element.classList.add('active-force');
      });
    });
  }

  if (ctaIngredientsElements.length > 0) {
    ctaIngredientsElements[0].addEventListener('click', function() {
      if (scrollonElements.length > 0) {
        scrollonElements.forEach(function(element) {
          element.classList.remove('active-force', 'active');
        });
      }

      ctaIngredientsElements.forEach(function(element) {
        element.classList.add('active-force');
      });
    });
  }
});

/* Prueba Enero 16 2025 */

function addBusinessDays(date, days) {
  let businessDaysAdded = 0;
  while (businessDaysAdded < days) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) { // No contar fines de semana
      businessDaysAdded++;
    }
  }
  return date;
}

function getDeliveryDateVariant() {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const dayOfWeek = now.getDay(); // 0 (Domingo) a 6 (Sábado)

  let sendDate = new Date(now);

  if (dayOfWeek === 5 || dayOfWeek === 6 || dayOfWeek === 0) {
    // Si es viernes, sábado o domingo, el envío es el lunes
    const daysUntilMonday = (8 - dayOfWeek) % 7;
    sendDate.setDate(sendDate.getDate() + daysUntilMonday);
  } else if (hour > 13 || (hour === 13 && minute > 30)) {
    // Después de 1:30 PM entre lunes y jueves, añadir 2 días hábiles
    sendDate = addBusinessDays(sendDate, 2);
  } else {
    // Antes de 1:30 PM entre lunes y jueves, añadir 1 día hábil
    sendDate = addBusinessDays(sendDate, 1);
  }

  return sendDate;
}

function getEstimatedDeliveryDates(sendDate) {
  const positiveDelivery = new Date(sendDate);
  const negativeDelivery = new Date(sendDate);

  // Sumar 2 días hábiles para la entrega positiva
  let positiveDaysToAdd = 2;
  while (positiveDaysToAdd > 0) {
    positiveDelivery.setDate(positiveDelivery.getDate() + 1);
    if (positiveDelivery.getDay() !== 0 && positiveDelivery.getDay() !== 6) {
      positiveDaysToAdd--;
    }
  }

  // Sumar 5 días hábiles para la entrega negativa
  let negativeDaysToAdd = 5;
  while (negativeDaysToAdd > 0) {
    negativeDelivery.setDate(negativeDelivery.getDate() + 1);
    if (negativeDelivery.getDay() !== 0 && negativeDelivery.getDay() !== 6) {
      negativeDaysToAdd--;
    }
  }

  return { positiveDelivery, negativeDelivery };
}

function formatDateShort(date) {
  const daysOfWeek = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"];
  const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

  const dayName = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = months[date.getMonth()];

  return `${dayName}, ${day} ${month}`;
}



setTimeout(function () {
  const sendDate = getDeliveryDateVariant();
  const { positiveDelivery, negativeDelivery } = getEstimatedDeliveryDates(sendDate);

  const formattedSendDate = formatDateShort(sendDate);
  const formattedPositiveDelivery = formatDateShort(positiveDelivery);
  const formattedNegativeDelivery = formatDateShort(negativeDelivery);

  $('.delivery-info-variant .send-date').html(
    `${formattedSendDate}`
  );

  $('.delivery-info-variant .delivery-date').html(
    `${formattedPositiveDelivery} - ${formattedNegativeDelivery}`
  );

}, 500);